// extracted by mini-css-extract-plugin
export default {"nodes-tree-wrapper":"inspection-type-master-form_nodes-tree-wrapper__ZFYYq"};